import { React, useEffect, useRef, useState } from "react";

import { SearchField } from "./SearchField.js";

import { Item, useListState } from "react-stately";
import { mergeProps, useFocusRing, useListBox, useOption } from "react-aria";

export const ComboBox = (props) => {
  let {
    list_name,
    label_name,
    selection_mode,
    list_of_items,
    checked,
    setChecked,
    outsider_list,
  } = props;

  let [currentSearchText, setCurrentSearchText] = useState("");

  let current_list = list_of_items.filter((item) =>
    item.item_name.toLowerCase().includes(currentSearchText.toLowerCase())
  );

  let [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    const format_selectedKeys = Array.from(selectedKeys);
    //setChecked(format_selectedKeys)

    let outsider_value_to_keep = outsider_list.filter((item) =>
      checked.includes(item)
    );

    let new_checked = [...format_selectedKeys, ...outsider_value_to_keep];
    setChecked(new_checked);
  }, [selectedKeys]);

  useEffect(() => {
    if ((checked.length == 0) & (selectedKeys.length !== 0)) {
      setSelectedKeys([]);
    }
  }, [checked]);

  return (
    <div className={`${list_name}_box_container`}>
      <SearchField
        className={`${list_name}`}
        label={`Search for ${label_name}`}
        onChange={setCurrentSearchText}
        onClear={() => setCurrentSearchText("")}
        //list={genreList}
      />
      <div>
        <ListBox
          aria-label={`${label_name}`}
          selectionMode={selection_mode}
          items={current_list}
          selectedKeys={selectedKeys}
          onSelectionChange={setSelectedKeys}
        >
          {(item) => <Item key={item.item_name}>{item.item_name}</Item>}
        </ListBox>
      </div>
    </div>
  );
};

const ListBox = (props) => {
  // Create state based on the incoming props
  let state = useListState(props);

  // Get props for the listbox element
  let ref = useRef(null);
  let { listBoxProps } = useListBox(props, state, ref);

  return (
    <ul
      {...listBoxProps}
      ref={ref}
      style={{
        padding: 0,
        margin: "5px 0",
        listStyle: "none",
        border: "1px solid gray",
        maxWidth: 250,
        maxHeight: 300,
        overflow: "auto",
      }}
    >
      {[...state.collection].map((item) => (
        <Option key={item.key} item={item} state={state} />
      ))}
    </ul>
  );
};

const Option = ({ item, state }) => {
  // Get props for the option element
  let ref = useRef(null);
  let { optionProps, isSelected, isDisabled, isFocused } = useOption(
    { key: item.key },
    state,
    ref
  );

  // Determine whether we should show a keyboard
  // focus ring for accessibility
  let { isFocusVisible, focusProps } = useFocusRing();

  return (
    <li
      {...mergeProps(optionProps, focusProps)}
      ref={ref}
      style={{
        background: isSelected
          ? "blueviolet"
          : isFocused
          ? "blueviolet"
          : "transparent",
        color: isDisabled ? "#aaa" : isSelected ? "white" : null,
        padding: "2px 5px",
        outline: isFocusVisible ? "2px solid orange" : "none",
      }}
    >
      {item.rendered}
    </li>
  );
};
